import { COLORS } from '../../../configs/config'
import { Div } from '../../../base/components/native/div'
import { Img } from '../../../base/components/native/img'
import { Base } from '../../../base/components/base'
import router from '../../../base/lib/router'
import { AddIcon } from '../../shared/add-icon/add-icon'
import { ABSOLUTE } from '../../../base/helpers/style'
import { HomeTitle } from './home-title'
import { MenuIcon } from '../../menu/menu-icon'
import { ProfileIcon } from '../../shared/profile/profile-icon'

export const HomeHeader = () => {

    const base = Base('div')
    const title = HomeTitle()
    const menuIcon = MenuIcon()
    const profileIcon = ProfileIcon()

    const shadow = Div()
    shadow.cssClass({
        opacity: '0',
        boxShadow: '0 0 6px #23435f59',
        ...ABSOLUTE,
        transition: 'all .44s',
        pointerEvents: 'none'
    })
    base.append(profileIcon, title, menuIcon, shadow)
    base.cssClass({
        position: 'fixed',
        top: '0',
        left: '0',
        right: '0',
        display: 'flex',
        justifyContent: 'space-between',
        zIndex: '999',
        transition: 'all .44s',
        height: '60px',
        backgroundColor: '#e4f0ff'
    })

    return {
        ...base,
        up() {
            base.style({
                transform: 'translateY(-76px)'
            })
        },
        down() {
            base.style({
                transform: 'translateY(0px)'
            })
        },
        showShadow() {
            shadow.style({
                opacity: '1'
            })
        },
        hideShadow() {
            shadow.style({
                opacity: '0'
            })
        }
    }
}